/**
 * Extract a date's YYYY-MM-DD string from its UTC time.
 *
 * For example, if the given Date is 2024-08-20 22:00:00 Central timezone, that
 * would be 2024-08-21 03:00:00 UTC timezone. This function returns
 * "2024-08-21".
 *
 * See dateToYYYYMMDDInLocalTimezone() if you want the date in its local timezone
 */
export function dateToYYYYMMDD(date: Date): string {
  return date.toISOString().split('T').shift();
}
